module.exports = __webpack_public_path__ + "media/react/marketing/sections/faq/assets/question_marks_bg-dbc0ef1b22e5a36eb728777a12739788.svg";